Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReview
  constructor: (builder) ->
    @text = builder.getText()
    @createdAt = builder.getCreatedAt()
    @contentId = builder.getContentId()
    @reviewId = builder.getReviewId()
    @starRating = builder.getStarRating()

  getText: =>
    @text

  getCreatedAt: =>
    @createdAt

  getContentId: =>
    @contentId

  getReviewId: =>
    @reviewId

  getStarRating: =>
    @starRating
